export interface PdsPopoverEventDetail {
  componentId: string;
  popoverType: 'auto' | 'manual';
}

